import { useEffect, useRef } from 'react';

// A question with two answers, over the modal. The prototype's own
// `.confirm-dialog` (customer-booking-portal stylesheet): a title, one line of
// why, and the actions right-aligned — the destructive one last and red.
// Escape is the safe answer. Focus lands on the safe answer too, so Enter
// cannot discard anything by accident.
export interface ConfirmDialogProps {
  title: string;
  message: string;
  confirmLabel: string;
  cancelLabel: string;
  danger?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmDialog({ title, message, confirmLabel, cancelLabel, danger, onConfirm, onCancel }: ConfirmDialogProps) {
  const safe = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    safe.current?.focus();
    const h = (e: KeyboardEvent) => {
      if (e.key !== 'Escape') return;
      e.stopPropagation();
      onCancel();
    };
    // Capture, so the shell's own Escape-to-close underneath never sees it.
    window.addEventListener('keydown', h, true);
    return () => window.removeEventListener('keydown', h, true);
  }, [onCancel]);
  return (
    <div className="confirm-back" role="presentation">
      <div className="confirm-dialog" role="dialog" aria-modal="true" aria-labelledby="confirm-title" aria-describedby="confirm-msg">
        <h2 className="confirm-title" id="confirm-title">{title}</h2>
        <p className="confirm-msg" id="confirm-msg">{message}</p>
        <div className="confirm-actions">
          <button type="button" className="btn" ref={safe} onClick={onCancel}>{cancelLabel}</button>
          <button type="button" className={'btn ' + (danger ? 'danger' : 'primary')} onClick={onConfirm}>{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}
